import type { ComponentProps, ReactNode } from 'react';
import styles from './styles.module.scss';

interface AnimatedSidebarButtonProps extends ComponentProps<'button'> {
  onClick: VoidFunction;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  tooltip?: string;
}

const AnimatedSidebarButton = (props: AnimatedSidebarButtonProps) => {
  const { className = '', onClick, children, disabled, tooltip, ...otherProps } = props;
  return (
    <button
      type="button"
      className={`${styles.animatedSidebarButton} ${className}`}
      onClick={onClick}
      disabled={disabled}
      title={tooltip}
      {...otherProps}
    >
      {children}
    </button>
  );
};

export default AnimatedSidebarButton;
